import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import { PaziaInput } from "components/atoms";
import { PaziaFormButton } from "components/atoms";
import { ClientIconsDropdown } from "../ClientIconsDropdown";

interface ResourceTabFormProps {
  onSubmit: (data: ResourceTabFormValues) => Promise<void>;
  tab?: { name: string; icon: string } | null;
}
export const ResourceTabForm = ({ onSubmit, tab }: ResourceTabFormProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      [FORM_NAMES.NAME]: tab?.name ?? "",
      [FORM_NAMES.ICON]: tab?.icon ?? ",",
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <PaziaInput name={FORM_NAMES.NAME} label="Nazwa" />
        <ClientIconsDropdown />
        <PaziaFormButton title="Zapisz" className="mt-4" />
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  NAME: "name",
  ICON: "icon",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NAME]: yup.string().required(),
    [FORM_NAMES.ICON]: yup.string().required(),
  })
  .required();

export type ResourceTabFormValues = yup.InferType<typeof schema>;
